<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeThisModal()" />
</div>
<ion-content>
  <div *ngIf="!showConfirmation">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-title class="smaller">
            <h1>Betalingsutsettelse</h1>
          </ion-title>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <div class="info-grid">
            <p class="bold">Faktura</p>
            <p>Beløp:</p>
            <p>{{ faktura.belopTotal }} kr</p>
            <p>Periode:</p>
            <p>{{ periodString }}</p>
            <p>Forfall:</p>
            <p>
              {{originalForfall.toLocaleDateString('nb', { day: 'numeric',
              month: 'long', year: 'numeric' })}}
            </p>
          </div>

          <p class="">Velg ny ønsket betalingsdato:</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="flex-center">
          <div class="datepicker-here" id="airUtsettelseHour"></div>
        </ion-col>
      </ion-row>

      <!-- <ion-row>
        <ion-col class="m-3 flex-center">
          <div class="selected-date">
            <div id="bf_time">
              <table width="100%">
                <tr>
                  <td width="100%">
                    <span>
                      <ion-icon name="calendar"></ion-icon>&nbsp;{{ selectedDate
                      | date : 'd. MMMM yyyy' : '' : 'nb' }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </ion-col>
      </ion-row> -->

      <ion-row class="m-3">
        <ion-col>
          <div>
            <ion-button class="dark bekreft" (click)="bekreftUtsettelse()"
              >Bekreft utsettelse til <br />
              {{ selectedDate | date : 'd. MMMM' : '' : 'nb' }}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="warningtext flex-center m-3">
          <div>
            <p>
              Du kan utsette fakturaene maks 30 dager fremover i tid.
              Utsettelsen kan gjøres en gang.
            </p>
            <p>
              Du benytter samme KID-nummer som på den opprinnelige fakturaen.
            </p>
            <p>
              Vær oppmerksom på at vi ikke sender ut noen bekreftelse på at
              utsettelse er gjennomført. Det kan ta litt tid før endringen vises
              i appen.
            </p>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>

  <div *ngIf="showConfirmation">
    <ion-row>
      <ion-col>
        <ion-title class="smaller">
          <h1>Suksess!</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row class="mt-8">
      <ion-col>
        <img src="/assets/img/shared/success.svg" />
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <p>Betalingsutsettelse ble gjennomført</p>
        <div class="info-grid">
          <p class="bold">Faktura</p>
          <p>Periode:</p>
          <p>{{ periodString }}</p>
          <p>Beløp:</p>
          <p>{{ faktura.belopTotal }} kr</p>
          <p>Forfall:</p>
          <p class="bold">{{ selectedDate.toLocaleDateString('nb') }}</p>
        </div>
        <p class="warningtext">
          Vær oppmerksom på at vi ikke sender ut noen bekreftelse på at
          utsettelse er gjennomført. Det kan ta litt tid før endringen vises i
          appen.
        </p>
      </ion-col>
    </ion-row>
  </div>
</ion-content>
